import mutate from '@/utils/mutateWrapper'
import { REPORT_CHEF_ISSUE, REPORT_ORDER_ISSUE } from '../gql/issues.gql'

export const reportChefIssue = (id, data) =>
  mutate(REPORT_CHEF_ISSUE, { id, data })

export const reportOrderIssue = (id, data) =>
  mutate(REPORT_ORDER_ISSUE, { id, data })
